export default __webpack_public_path__ + "static/media/roadtrip.453226ce.jpg";